import { LocalShipmentItem } from './local-shipment-item.model';
import { LocalLoadDocument } from './local-load-document.model';

export class LocalShipment {

  public id: string;
  public shipmentId: string;
  public shipmentNumber: string;
  public salesOrderNumber: string;
  public comment: string;
  public items: LocalShipmentItem[] = [];
  public expanded                   = false;
  public pod: LocalLoadDocument;

  static fromDto(s): LocalShipment {
    const shipment = new LocalShipment();

    if (!s) {
      return null;
    }

    shipment.id             = s.id;
    shipment.shipmentId     = s.shipment_id;
    shipment.shipmentNumber = s.shipment_number;
    shipment.salesOrderNumber = s.sales_order_number;
    shipment.comment        = s.comment;
    shipment.items          = s.items.map((item) => LocalShipmentItem.fromDto(item));

    return shipment;
  }

  expand() {
    this.expanded = !this.expanded;
  }
}
